module.exports = __webpack_public_path__ + "static/TAN_ASFL_Logo-Loop_v02-859579db4ec76a64cf7f750c943c4838.png";